// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"207":"cda8c1b8","224":"39384f82"}[chunkId] + ".js";
};